import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { GraphClient } from '../../api/MSGraphExtensions';
import { AppRoleAssignmentDto, GraphUserDto } from '../../api/msGraphApi';
import { RootState } from '../reducers';
import { LoggedEmployeeState } from '../reducers/loggedEmployeeReducer';

export const setLoggedEmployeeData = createAction<GraphUserDto>('employee/setLoggedEmployeeData');
export const setLoggedEmployeeRoles = createAction<AppRoleAssignmentDto[]>('employee/setLoggedEmployeeRoles');

export const getEmployeeData = createAsyncThunk<void, void>(
    'employee/getEmployeeData',
    async (payload: void, thunkAPI) => {
        const me = await GraphClient.getMe();
        thunkAPI.dispatch(setLoggedEmployeeData(me));

        const roles = await GraphClient.getUserAppRoles(me.id ?? '');
        thunkAPI.dispatch(setLoggedEmployeeRoles(roles));
    },
    {
        condition: (arg: void, thunkAPI: { getState: any }) => {
            const employeeState: LoggedEmployeeState = (thunkAPI.getState() as RootState).loggedEmployee;
            const employeeInfo: GraphUserDto | null = employeeState.basicEmployee;

            return employeeInfo === null;
        },
    },
);
